export enum ProcessStatus {
    InProgress, // 0
    None, // 1
    Error, // 2
    Success, // 3
}